import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { InvitedFacility } from 'src/app/post-login/services/multi-facility.model';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { HaloModalOptions, HaloModalService } from 'src/app/core/halo-modal/halo-modal';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-pending-facilities',
  templateUrl: './pending-facilities.component.html',
  styleUrls: ['./pending-facilities.component.scss'],
})
export class PendingFacilitiesComponent implements OnInit {
  @Input() pendingFacilities: InvitedFacility[];
  @Output() onRemoveFacility: EventEmitter<void> = new EventEmitter();

  selectedInviteFacility: InvitedFacility;
  selectedTranslateParam: string[];

  @ViewChild('modalConfirmResendInviteFooter') modalConfirmResendInviteFooter: TemplateRef<any>;
  @ViewChild('modalConfirmDeleteFooter') modalConfirmDeleteFooter: TemplateRef<any>;

  constructor(
    private _service: MultiFacilityService,
    private _toast: HaloToastService,
    private _loader: HaloLoaderService,
    private _util: CommonUtil,
    private _modal: HaloModalService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {}

  ngOnInit(): void {}

  openModel(action: string, selectedInviteFacility: InvitedFacility) {
    this.selectedInviteFacility = selectedInviteFacility;
    let { approverEmail, requestedFacilityName, requestedFacilityId } = selectedInviteFacility;
    this.selectedTranslateParam = [approverEmail, requestedFacilityName, requestedFacilityId];

    if (action === 'REMOVE') {
      this._modal.add({
        dismissible: true,
        titleUppercase: true,
        title: this._util.translateText('PENDING.FACILITY.REMOVE.MODAL.TITLE'),
        icon: 'icon-l-warning',
        iconClass: 'error',
        message: this._util.translateText('DELETE.MODAL.MESSAGE'),
        footerTemplate: this.modalConfirmDeleteFooter,
      });
    } else {
      this._modal.add({
        dismissible: true,
        titleUppercase: true,
        title: this._util.translateText('INVITE.FACILITY.RESEND'),
        message: this._util.replaceValueAsHTMLOnTranslatedText(
          'PENDING.FACILITY.RESEND.MODAL.MSG',
          this.selectedTranslateParam
        ),
        footerTemplate: this.modalConfirmResendInviteFooter,
      });
    }
  }

  dismissModal() {
    this._modal.close();
  }

  async resendInvitation() {
    this._loader.startProcess();
    try {      
      this._amplitudeAnalytics.logEvent({elementName: 'Resend Invitation', action: 'Submit'});
      await this._service.resendInvite(this.selectedInviteFacility);
      this.dismissModal();
      this._toast.creatToast(
        this._util.replaceValueAsHTMLOnTranslatedText(
          'PENDING.FACILITY.RESEND.SUCCESS.MSG',
          this.selectedTranslateParam
        )
      );
    } catch (error) {
      console.error('API error.');
    }
    this._loader.endProcess();    
  }

  async removeInvitation() {
    this._loader.startProcess();
    try {
      this._amplitudeAnalytics.logEvent({elementName: 'Remove Invitation', action: 'Submit'});
      await this._service.removeInvite(this.selectedInviteFacility.requestedFacilityId);
      this._toast.creatToast(
        this._util.replaceValueAsHTMLOnTranslatedText(
          'PENDING.FACILITY.REMOVE.SUCCESS.MSG',
          this.selectedTranslateParam
        )
      );

      // remove facility from list
      this.pendingFacilities = this.pendingFacilities.filter((facility) => {
        return facility.requestedFacilityId != this.selectedInviteFacility.requestedFacilityId;
      });
      this.dismissModal();
      this.onRemoveFacility.emit();
    } catch (error) {
      console.error('API error.');
    }
    
    this._loader.endProcess();
  }
}
